export default __webpack_public_path__ + "static/media/contact-light.9805c449.svg";